import { Navigate, useRoutes } from "react-router-dom";
import Home from "../pages/Home";
import { TicketPage } from "../pages/sections/TicketPage";
import Booking from "../pages/sections/Booking";
import Booked from "../pages/sections/Booked";
import LandingPage from "../pages/Landing";
import ShortEventRedirect from "../pages/sections/ShortEventRedirect";


export function Routes() {
  let element = useRoutes([
    // Compact share links → redirect to canonical /event/:name/:id
    // /e/:code/:name = restaurantId compressed (works without new API)
    // /e/:code = EventId compressed (uses restaurantevent/link/{eventId})
    {
      path: "/e/:code/:name",
      element: <ShortEventRedirect />,
    },
    {
      path: "/e/:code",
      element: <ShortEventRedirect />,
    },
    {
      path: "/event/poe",
      element: (
        <Navigate
          to="/event/Listening-Session-with-Poe/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=whatsapp"
          replace
        />
      ),
    },
    {
      path: "/event/the-good-classroom",
      element: (
        <Navigate
          to="/event/THE-GOOD-CLASSROOM/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },
    {
      path: "/event/Breathe-and-Brunch",
      element: (
        <Navigate
          to="/event/Breathe-and-Brunch/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },
    {
      path: "/event/The-Leather-Table",
      element: (
        <Navigate
          to="/event/The-Leather-Table/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },
    {
      path: "/event/Chi's-Fashion-Week-Dinner",
      element: (
        <Navigate
          to="/event/Chi's-Fashion-Week-Dinner/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },
    {
      path: "/event/The-Lounge-Sessions-with-Deena-Ade",
      element: (
        <Navigate
          to="/event/The-Lounge-Sessions-with-Deena-Ade/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },

    {
      path: "/event/The-Lounge-Sessions",
      element: (
        <Navigate
          to="/event/The-Lounge-Sessions/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },
    {
      path: "/event/Owambe-Noir",
      element: (
        <Navigate
          to="/event/Owambe-Noir/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },
    {
      path: "/event/Good-Moves-Tuesday-",
      element: (
        <Navigate
          to="/event/Good-Moves-Tuesday-/8b82860e-54f2-436f-9b4c-a0aa03d7e66b?utm_source=website"
          replace
        />
      ),
    },
   
    
    {
      path: "/event/Outgun-Live-At-The-House",
      element: (
        <Navigate
          to="/event/Outgun-Live-At-The-House/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },
   
  
    {
      path: "/event/FRIDAY-LIBATIONS",
      element: (
        <Navigate
          to="/event/FRIDAY-LIBATIONS/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },
    {
      path: "/event/Choplife-Cookout-Vol-6",
      element: (
        <Navigate
          to="/event/Choplife-Cookout-Vol-6/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },
    {
      path: "/event/Girl-Dinner-Party",
      element: (
        <Navigate
          to="/event/Girl-Dinner-Party/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },
  
    {
      path: "/event/Girl-Dinner",
      element: (
        <Navigate
          to="/event/Girl-Dinner/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },
    {
      path: "/event/Datare-at-40",
      element: (
        <Navigate
          to="/event/Datare-at-40/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },
    {
      path: "/event/The-Living-Room-Sessions",
      element: (
        <Navigate
          to="/event/The-Living-Room-Sessions/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },
    {
      path: "/event/RNB-NIGHT",
      element: (
        <Navigate
          to="/event/RNB-NIGHT/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },
    {
      path: "/event/FRIDAY-LIBATIONS",
      element: (
        <Navigate
          to="/event/FRIDAY-LIBATIONS/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },
    {
      path: "/event/choplife-cookout-vol-5",
      element: (
        <Navigate
          to="/event/Choplife-Cookout-Vol-5/4d44db8b-5f2e-4f15-95af-fecf72fdfb87?utm_source=website"
          replace
        />
      ),
    },
  
    {
      element: <Home />,
      children: [
        {
          path: "/event/:name/:id",
          element: <TicketPage />,
        },
        {
          path: "/booking/:name/:id",
          element: <Booking />,
        },
      ],
    },
    {
      path: "/booked",
      element: <Booked />,
    },
    {
      path: "/:name",
      element: <LandingPage />,
    },
  ]);
  return element;
}
